<template>
  <b-modal
    title="Необходима перезагрузка"
    ok-only
    size="lg"
    ref="modal"
    @ok="onOk"
    @cancel="onCancel"
    no-close-on-esc
    no-close-on-backdrop
  >
    <div v-html="notification" />
    <p>Страница будет перезагружена автоматически через {{ value }} секунд</p>
    <b-progress
      :max="secondsWait"
      :value="value"
      show-value
      animated
      variant="primary"
    />
    <template v-slot:modal-footer="{ ok, cancel }">
      <div class="d-flex flex-row">
        <b-button variant="primary" @click="ok" class="mr-1">
          Перезагрузить сейчас
        </b-button>
        <b-button variant="secondary" @click="cancel">
          Отложить на 1 час
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'

import { notificationsMapper } from '@/store/modules/notifications'

const Mappers = Vue.extend({
  computed: {
    ...notificationsMapper.mapState(['reloadNotification'])
  }
})

@Component
export default class ReloadModal extends Mappers {
  $refs!: { modal: BModal }

  private secondsWait = 300
  private secondsDelay = 60 * 60 * 1000
  private value = 0
  private interval?: ReturnType<typeof setInterval>

  get notification() {
    if (this.reloadNotification) {
      return this.reloadNotification
    }
    return `Необходима перезагрузка страницы.`
  }

  onOk() {
    location.reload()
  }

  onCancel() {
    setTimeout(() => {
      this.show()
    }, this.secondsDelay)

    clearInterval(this.interval!)
  }

  public show() {
    this.$refs.modal.show()
    this.value = this.secondsWait
    this.interval = setInterval(() => {
      if (this.value > 0) {
        this.value--
      } else {
        clearInterval(this.interval!)
        location.reload()
      }
    }, 1000)
  }
}
</script>
